/**
 * A KUPAC KERESÉSE (`/`) — tiszta függvények, React nélkül.
 *
 * A D9 kiosztásában a `/` „keresés az aktuális listában". A munkalistán ez a
 * kupacot szűkíti: a könyvelő tudja, hogy „valahol itt van a Shell-es
 * nyugta", és nem akar érte végiggörgetni kétszáz sort.
 *
 * ⚠️ A KERESÉS A BETÖLTÖTT SOROKON FUT, nem a teljes kupacon. A szerver
 * `WORKLIST_LIMIT = 200`-nál vág; a `totals.itemCount` viszont a TELJES
 * darabszám. Csonkolt listán tehát a „nincs találat" NEM azt jelenti, hogy
 * nincs ilyen bizonylat — csak azt, hogy a betöltött kétszázban nincs. Ezt a
 * felület KIMONDJA (`worklist.search.truncated`), mert egy hallgatólagos
 * „nincs ilyen" pont a 2.4d „hamis nulla" bukásmódja: a könyvelő elhinné,
 * hogy nincs mit keresnie.
 *
 * A SZERVEROLDALI KERESÉS az M1-é (`hipotezisek.md` §484: „könyvelői
 * kezelőfelület, státusz, keresés, mappák"). Amíg nincs, a felület a saját
 * korlátját vállalja, nem elrejti.
 */

import { matchesQuery } from '@/utils/fold';
import type { WorklistItem } from './types';

/**
 * AMIBEN KERESÜNK — pontosan az, ami a SORON LÁTSZIK, plusz a cégnév.
 *
 * A cégnév akkor is beleszámít, amikor a sorból kimarad (egyetlen cégnél
 * elhagyjuk, mert ott zaj): a könyvelő fejében a papír a CÉGHEZ tartozik, és
 * „Szegedi"-re keresve joggal várja a találatot. A számlaszám ellenben NEM
 * látszik a soron — mégis benne van, mert a könyvelő gyakran épp azt kapja
 * meg telefonon.
 */
export function searchableText(item: WorklistItem): string {
  return [item.partnerName, item.companyName, item.invoiceNumber]
    .filter((part) => part !== null)
    .join(' ');
}

/** A kupac szűkítése. ÜRES keresés = a teljes lista, nem a nulla. */
export function filterItems(items: WorklistItem[], query: string): WorklistItem[] {
  if (query.trim().length === 0) {
    return items;
  }
  return items.filter((item) => matchesQuery(searchableText(item), query));
}
